module.exports = __webpack_public_path__ + "assets/images/USDUNFIT1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT1.png
// module id = 1465
// module chunks = 1